import { WorkplaceProvider } from './../../providers/workplace/workplace';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController } from 'ionic-angular';

import { globalDefines } from '../../app/app.constants';
import { User } from '../../models/user';
import { TimetableProvider } from '../../providers/timetable/timetable';
import { UserProvider } from '../../providers/user/user';

@IonicPage()
@Component({
  selector: 'page-user-info',
  templateUrl: 'user-info.html',
})
export class UserInfoPage {

  mode;
  timetables;
  title: string;
  user = {} as User;
  userTimetables = [];
  workplaces;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public timetableProvider: TimetableProvider,
    public userProvider: UserProvider,
    public workplacesProvider: WorkplaceProvider,
  ) {
    this.timetables = this.timetableProvider.getTimetables();
    this.workplaces = this.workplacesProvider.getWorkplaces();
    this.mode = this.navParams.get('mode')
    this.initMode();
  }

  initMode() {
    switch(this.mode) {
      case 'info': { 
        this.title = 'Información'; 
        this.user = this.navParams.get('user');
        this.getUserTimetables();
        break
      };

      case 'edit': { 
        this.title = 'Editar'; 
        this.user = this.navParams.get('user');
        this.getUserTimetables();
        break 
      };

      case 'add': { 
        this.title = 'Añadir'; 
        break
      };
    }
  }

  save() {
    if(this.user.name && this.user.dni && this.user.email && this.user.role != null) {
      this.timetableProvider.getTimetablesByIdsOnce(this.userTimetables).subscribe(timetables => {
        console.log(timetables);

        if(timetables.length > 0) this.user['timetables'] = timetables;
        else this.user['timetables'] = null;

        this.userProvider.save(this.user).then(() => {
          this.user.role = Number(this.user.role)

          this.navCtrl.pop();
        })        
      })
    }
    else this.showMessage(`Introduzca todos los datos.`);
  }

  private getUserTimetables() {
    if(this.user.timetables) this.user.timetables.forEach(timetable => this.userTimetables.push(timetable.key))
  }

  private showMessage(message: string) {
    this.toastCtrl.create({message: message, duration: globalDefines.defaultToastDuration}).present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/user-info/user-info.ts